// tslint:disable:no-any
import { _reduce } from 'libs/lodash';

export const stringsTuple = <T extends string[]>(...args: T) => args;

// @ts-ignore
export const mapStrings = <T>(tuple: string[]): { [key in T]: T } => {
  return _reduce(tuple, (map: any, str: string) => ({ ...map, [str]: str }), {});
};
